export default [
  {
    title: "Game",
    icon: { icon: "tabler-device-gamepad-2" },
    permissionIds: [21, 27, 41, 36],
    children: [
      {
        title: "QL game",
        to: { name: "game-list", meta: { permissionId: 21 } },
      },
      {
        title: "QL FUS game",
        to: { name: "game-fus", meta: { permissionId: 27 } },
      },
      {
        title: "QL danh mục game H5",
        to: { name: "game-h5-category", meta: { permissionId: 41 } },
      },
      {
        title: "QL game H5",
        to: { name: "game-h5", meta: { permissionId: 36 } },
      },
    ],
  },
];
